export const EXPERIMENTS = {
  AI_ASSISTANT: 'specs.form-app.AiFormAssistant',
  AI_ASSISTANT_TYPING_EFFECT: 'specs.form-app.AiFormAssistantTypingEffect',
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  USE_CSS_VARS_ONLY: 'specs.forms.UseCSSVarsOnly',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
};
